module.exports = __webpack_public_path__ + "media/images/item/bg_tab-e4bc332efa078373645c6dea1160d5d2.png";